/* Product-owned state; detached quick-add generations own no document listeners. */
(() => {
  const rootFor = (node) => node.closest('product-info, [id^="ProductInfo-"], section[id^="MainProduct-"]');
  const primaryForms = (root, fallbackId) => {
    const variant = root.querySelector('.variant-input:checked, input[name="variant"]:checked');
    const id = variant ? variant.getAttribute('form') : fallbackId;
    if (!id) return [];
    const productId = root.dataset.productId;
    return Array.from(root.querySelectorAll('form[action*="/cart/add"]')).filter((form) => {
      const owner = form.querySelector('input[name="product-id"]');
      return form.getAttribute('id') === id && (productId && owner && owner.value === productId);
    });
  };

  // Payment terms use a separate legitimate form; synchronize only its variant, never its plan/quantity.
  const syncInstallmentVariant = (root, formId, variantId) => {
    if (!formId?.startsWith('product-form-') || !root.dataset.productId) return;
    const installmentId = formId.replace('product-form-', 'product-form-installment-');
    root.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      if (form.getAttribute('id') !== installmentId || form.getAttribute('data-beleaev-installment-product-id') !== root.dataset.productId) return;
      form.querySelectorAll('input[name="id"]').forEach(input => { if (input.value !== variantId) input.value = variantId; });
    });
  };

  // Quote each variant with the same fallback used when its interval list is rebuilt.
  const allocationFor = (variant, planId) => variant?.plans.find((plan) => String(plan.id) === planId) || variant?.plans[0];

  class BeleaevProductTotal extends HTMLElement {
    connectedCallback() {
      this.root = rootFor(this);
      if (!this.root) return;
      this.abort = new AbortController();
      const update = () => this.update();
      ['input', 'change', 'beleaev:purchase-change'].forEach((name) =>
        this.root.addEventListener(name, update, { signal: this.abort.signal }));
      this.observer = new MutationObserver(update);
      this.observer.observe(this.root, { childList: true, characterData: true, subtree: true });
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
    update() {
      if (!this.isConnected || !this.root?.isConnected) return;
      const quantity = this.root.querySelector('quantity-input');
      const quantityInput = quantity?.querySelector('input');
      const forms = primaryForms(this.root, quantityInput?.getAttribute('form') || quantity?.closest('form')?.getAttribute('id'));
      const form = forms.find((item) => item.getBoundingClientRect().height) || forms[0];
      const button = form?.querySelector('button[id^="ProductSubmitButton-"]');
      const row = button?.closest('.product-form__buttons');
      if (quantity && row && !quantity.contains(row) && quantity.parentElement !== row) row.insertBefore(quantity, button);
      // A same-ID foreign form can capture an explicit form attribute even after relocation.
      if (form && quantityInput && form.contains(quantityInput) && quantityInput.form !== form) quantityInput.removeAttribute('form');
      row?.classList.add('beleaev-row-wired');
      const shipping = this.root.querySelector('#bel-ship-timing');
      if (row && shipping) {
  if (this.root.closest('quick-add-modal')) {
    if (shipping.previousElementSibling !== row) row.after(shipping);
  } else if (shipping.parentElement !== row.parentElement) {
    row.before(shipping);
  }
}
      if (row && shipping) {
        row.parentElement.style.display = 'flex';
        row.parentElement.style.flexDirection = 'column';
        shipping.style.display = '';
      }
      if (this.root.querySelector('beleaev-purchase-options[data-active]')) return;
      if (this.root.dataset.blvPriceOwner === 'allocation') return;
      if (this.root.querySelector('beleaev-caviar-sample-rule, .beleaev-total-tasting')) this.updateAppstlePresentation(row);
      const checked = this.root.querySelector('.variant-input:checked');
      const label = checked && this.root.querySelector(`label[for="${CSS.escape(checked.id)}"] .variant-price`);
      const total = this.root.querySelector('[data-beleaev-total]');
      const amount = Math.max(1, Number(quantity?.querySelector('input')?.value) || 1);
      // PDP Appstle owns unit prices; retain its rendered currency formatting.
      const match = label?.textContent.trim().match(/^([^\d]*)([\d.,]+)(.*)$/);
      if (!total || !match) return;
      const decimal = match[2].lastIndexOf(',') > match[2].lastIndexOf('.') ? ',' : '.';
      const unit = Number(match[2].replace(decimal === ',' ? /\./g : /,/g, '').replace(',', '.'));
      const value = match[1] + (unit * amount).toFixed(2).replace('.', decimal) + match[3];
      if (Number.isFinite(unit) && total.textContent !== value) total.textContent = value;
    }
    updateAppstlePresentation(row) {
      const widget = this.root.querySelector('.appstle_sub_widget');
      const total = this.root.querySelector('.beleaev-total, .beleaev-total-tasting');
      if (!widget || !total) return;
      if (this.root.querySelector('beleaev-caviar-sample-rule') && row && widget.nextElementSibling !== row && !widget.contains(row)) row.before(widget);
      let line = this.root.querySelector('.beleaev-sub-line');
      if (!line) {
        line = document.createElement('div');
        line.className = 'beleaev-sub-line';
        line.style.cssText = 'align-items:center;flex-wrap:wrap;gap:10px;margin:0 0 4px';
        total.after(line);
      }
      const selected = this.root.querySelector('.variant-input:checked');
      const sampleIds = this.root.querySelector('beleaev-caviar-sample-rule')?.dataset.variantIds.split(',') || [];
      const subscribed = !sampleIds.includes(selected?.value) && !!widget.querySelector('.appstle_subscription_radio_wrapper input[type="radio"]:checked');
      line.hidden = !subscribed;
      line.style.display = subscribed ? 'flex' : 'none';
      total.style.display = subscribed ? 'none' : '';
      if (!subscribed) return;
      const values = [
        widget.querySelector('.appstle_subscription_amount_wrapper .appstle_subscription_amount')?.textContent.trim() || '',
        (widget.querySelector('.appstle_subscription_compare_amount') || widget.querySelector('.appstle_one_time_price_wrapper .appstle_subscription_amount'))?.textContent.trim() || '',
        widget.querySelector('.appstle_subscription_save')?.textContent.trim() || '',
      ];
      const signature = JSON.stringify(values);
      if (line.dataset.signature === signature) return;
      const styles = ['font-size:30px;font-weight:700;color:#C9A961', 'font-size:19px;text-decoration:line-through;color:#e6e6e6', 'font-size:13px;font-weight:700;color:#C9A961;border:1px solid #C9A961;border-radius:4px;padding:3px 9px'];
      line.replaceChildren(...values.filter(Boolean).map(value => {
        const node = document.createElement('span');
        node.style.cssText = styles[values.indexOf(value)];
        node.textContent = value;
        return node;
      }));
      line.dataset.signature = signature;
    }
  }

  class BeleaevPurchaseOptions extends HTMLElement {
    connectedCallback() {
      // Wait until injected markup and its JSON children are attached.
      queueMicrotask(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected || this.abort) return;
      this.root = rootFor(this);
      const data = this.querySelector('script[type="application/json"]');
      if (!this.root || !data) return;
      this.data = JSON.parse(data.textContent);
      const sampleIds = this.root.querySelector('beleaev-caviar-sample-rule')?.dataset.variantIds.split(',') || [];
      this.data.variants = this.data.variants.map(variant => sampleIds.includes(String(variant.id)) ? { ...variant, plans: [] } : variant);
      this.forms = primaryForms(this.root, this.dataset.formId);
      if (!this.forms.length) return;
      if (!this.closest('quick-add-modal')) {
        this.abort = new AbortController();
        const syncConsent = () => {
          // A late owner may reset either legitimate duplicate form; selection stays authoritative.
          const selected = this.root.querySelector('.variant-input:checked, input[name="variant"]:checked');
          this.forms = primaryForms(this.root, this.dataset.formId);
          if (selected && this.forms.length && this.data.variants.some(variant => String(variant.id) === selected.value)) {
            syncInstallmentVariant(this.root, selected.getAttribute('form'), selected.value);
            this.forms.forEach(form => form.querySelectorAll('input[name="id"]').forEach(input => {
              if (input.value !== selected.value) input.value = selected.value;
            }));
          }
          const oneTime = this.root.querySelector('.appstle_one_time_details_wrapper input[type="radio"]:checked');
          const subscription = this.root.querySelector('.appstle_subscription_radio_wrapper input[type="radio"]:checked');
          const plan = this.forms.some((form) => Array.from(form.querySelectorAll('input[name="selling_plan"]')).some((input) => !input.disabled && input.value));
          if (!oneTime && !subscription && !plan) return;
          this.forms.forEach((form) => form.querySelectorAll('small#shopify-buyer-consent[data-consent-type="subscription"]').forEach((consent) => {
            consent.hidden = !!oneTime && !subscription;
            if (consent.hidden) consent.style.setProperty('display', 'none', 'important');
            else consent.style.removeProperty('display');
          }));
        };
        const settle = () => queueMicrotask(syncConsent);
        this.root.addEventListener('change', settle, { capture: true, signal: this.abort.signal });
        this.root.addEventListener('click', settle, { capture: true, signal: this.abort.signal });
        this.root.addEventListener('submit', syncConsent, { capture: true, signal: this.abort.signal });
        this.root.addEventListener('beleaev:purchase-state-sync', syncConsent, { signal: this.abort.signal });
        this.consentObserver = new MutationObserver(syncConsent);
        this.consentObserver.observe(this.root, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'checked'] });
        syncConsent();
        return;
      }
      this.mode = this.querySelector('[data-purchase-mode]');
      this.plan = this.querySelector('[data-purchase-plan]');
      this.abort = new AbortController();
      this.root.addEventListener('change', (event) => {
        if (event.target === this.mode || event.target === this.plan || event.target.matches('.variant-input, input[name="quantity"]')) this.update();
      }, { signal: this.abort.signal });
      this.root.addEventListener('input', (event) => {
        if (event.target.matches('input[name="quantity"]')) this.update();
      }, { signal: this.abort.signal });
      // Inline variant-label handlers can stop propagation; settle after them.
      this.root.addEventListener('click', (event) => {
        if (event.target.closest('.variant-label, quantity-input')) queueMicrotask(() => this.update());
      }, { capture: true, signal: this.abort.signal });
      this.root.addEventListener('submit', (event) => {
        if (!this.forms.includes(event.target)) return;
        if (!this.update()) { event.preventDefault(); event.stopImmediatePropagation(); }
      }, { capture: true, signal: this.abort.signal });
      this.hidden = false;
      this.setAttribute('data-active', '');
      this.root.classList.add('beleaev-native-purchase');
      this.nativeObserver = new MutationObserver((records) => {
        if (records.some((record) => Array.from(record.addedNodes).some((node) => node.nodeType === 1 && (node.matches('.appstle_sub_widget, input[name="selling_plan"]:not([data-native-plan])') || node.querySelector('.appstle_sub_widget'))))) this.update();
      });
      this.nativeObserver.observe(this.root, { childList: true, subtree: true });
      this.root.querySelectorAll('[data-blv-appstle-shell]').forEach((shell) => { shell.hidden = true; shell.style.display = 'none'; });
      // Accelerated checkout's app-owned allocation can be stale in injected HTML.
      this.forms.forEach((form) => form.querySelectorAll('.shopify-payment-button').forEach((payment) => { payment.hidden = true; payment.style.display = 'none'; }));
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.consentObserver?.disconnect(); this.nativeObserver?.disconnect(); this.abort = null; }
    // Share the active campaign's eligibility and rounding with collection/PDP prices.
    oneTimePrice(variant) {
      const campaign = window.BeleaevWagyuLaunch;
      const offer = campaign?.active && campaign.offers?.find((item) => item.handles.includes(this.data.handle));
      const discount = Number(offer?.discount);
      return discount > 0 && discount < 100 ? Math.round(variant.price * (100 - discount) / 100) : variant.price;
    }
    update() {
      if (!this.isConnected) return false;
      const selected = this.root.querySelector('.variant-input:checked');
      const id = selected?.value || this.forms[0].querySelector('[name="id"]')?.value;
      const variant = this.data.variants.find((item) => String(item.id) === String(id));
      if (!variant) return false;
      syncInstallmentVariant(this.root, selected?.getAttribute('form') || this.dataset.formId, String(variant.id));
      const plans = variant.plans || [];
      this.mode.querySelector('[value="one-time"]').disabled = variant.required;
      this.mode.querySelector('[value="subscription"]').disabled = !plans.length;
      if (variant.required) this.mode.value = 'subscription';
      else if (!plans.length) this.mode.value = 'one-time';
      const previous = this.plan.value;
      const signature = JSON.stringify(plans);
      if (signature !== this.planSignature) {
        this.plan.replaceChildren(...plans.map((plan) => new Option(this.data.monthLabels?.[plan.name] || plan.name, String(plan.id))));
        const nextAllocation = allocationFor(variant, previous);
        if (nextAllocation) this.plan.value = String(nextAllocation.id);
        this.planSignature = signature;
      }
      const allocation = this.mode.value === 'subscription' ? plans.find((plan) => String(plan.id) === this.plan.value) : null;
      const valid = variant.available && (!variant.required || !!allocation) && (this.mode.value !== 'subscription' || !!allocation);
      this.plan.closest('label').hidden = this.mode.value !== 'subscription';
      this.querySelector('[data-purchase-consent]').hidden = !allocation;
      this.querySelector('[data-purchase-unavailable]').hidden = valid;
      const quantity = this.root.querySelector('quantity-input input[name="quantity"]');
      const amount = Math.max(1, Number(quantity?.value) || 1);
      this.root.querySelectorAll('.appstle_sub_widget').forEach((widget) => {
        widget.hidden = true;
        widget.style.setProperty('display', 'none', 'important');
        widget.querySelectorAll('input, select, button').forEach((input) => { input.disabled = true; });
      });
      this.forms.forEach((form) => {
        form.querySelectorAll('[name="id"]').forEach((input) => { input.value = String(variant.id); input.disabled = !valid; });
        form.querySelectorAll('input[name="selling_plan"]:not([data-native-plan])').forEach((input) => { input.disabled = true; });
        let sellingPlan = form.querySelector('input[data-native-plan]');
        if (!sellingPlan) { sellingPlan = document.createElement('input'); sellingPlan.type = 'hidden'; sellingPlan.name = 'selling_plan'; sellingPlan.setAttribute('data-native-plan', ''); form.append(sellingPlan); }
        sellingPlan.value = allocation ? String(allocation.id) : '';
        sellingPlan.disabled = !allocation || !valid;
        let qty = form.querySelector('input[name="quantity"]');
        if (!qty && quantity?.form !== form) { qty = document.createElement('input'); qty.type = 'hidden'; qty.name = 'quantity'; form.append(qty); }
        if (qty && qty !== quantity) qty.value = String(amount);
        form.querySelectorAll('[type="submit"]').forEach((button) => { button.disabled = !valid; });
      });
      const shipping = this.root.querySelector('#bel-ship-timing');
      const row = this.forms.map((form) => form.querySelector('button[id^="ProductSubmitButton-"]')?.closest('.product-form__buttons')).find(Boolean);
      if (this.root.closest('quick-add-modal') && row && shipping) {
        row.parentElement.style.display = 'flex';
        row.parentElement.style.flexDirection = 'column';
        shipping.style.setProperty('order', '1', 'important');
        if (shipping.previousElementSibling !== row) row.after(shipping);
      }
      const money = (cents) => new Intl.NumberFormat(this.data.locale, { style: 'currency', currency: this.data.currency }).format(cents / 100);
      this.root.querySelectorAll('.variant-input').forEach((input) => {
        const item = this.data.variants.find((entry) => String(entry.id) === input.value);
        const price = this.root.querySelector(`label[for="${CSS.escape(input.id)}"] .variant-price`);
        const plan = allocationFor(item, this.plan.value);
        if (item && price) {
          const value = money(this.mode.value === 'subscription' && plan ? plan.price : this.oneTimePrice(item));
          if (price.textContent !== value) price.textContent = value;
        }
      });
      const total = this.root.querySelector('[data-beleaev-total]');
      const value = money((allocation ? allocation.price : this.oneTimePrice(variant)) * amount);
      if (total && total.textContent !== value) total.textContent = value;
      const bottoms = this.root.querySelectorAll('.beleaev-price-bottom__value, .price__amount, .price__regular .price-item--regular, .price__sale .price-item--last');
      if (this.root.closest('quick-add-modal')) bottoms.forEach((bottom) => { if (bottom.textContent.trim() !== value) bottom.textContent = value; });
      return valid;
    }
  }
  customElements.define('beleaev-product-total', BeleaevProductTotal);
  customElements.define('beleaev-purchase-options', BeleaevPurchaseOptions);
})();

